module.exports = __webpack_public_path__ + "static/media/paxa.36c38e6f.png";